jQuery(function ($) {
  // Evita inicialização duplicada em temas/sections que recarregam scripts
  if (!window.__shippingCalcInitDone) {
    window.__shippingCalcInitDone = true;
    Shopify.Cart.ShippingCalculator.show({
      submitButton: "Calcular",
      submitButtonDisabled: "Calculando...",
      moneyFormat: moneyformat
    });
  }

  // --- util: debounce líder (aceita só o primeiro dentro da janela) ---
  function debounceLeading(fn, wait) {
    let inWindow = false, t = null;
    return function (...args) {
      if (inWindow) return;               // ignora cliques subsequentes
      inWindow = true;
      try { fn.apply(this, args); }       // executa o primeiro imediatamente
      finally {
        clearTimeout(t);
        t = setTimeout(() => { inWindow = false; }, wait);
      }
    };
  }

  // Estado global para travar múltiplas consultas simultâneas
  window.__freteBusy = false;
  let removeTimerId = null;

  function setBusy(state) {
    window.__freteBusy = state;
    const $btn = $(".get-rates-custom");
    if (state) {
      $btn.addClass("loading")
          .attr("value", "Calculando...")
          .prop("disabled", true)
          .css("pointer-events", "none");
      $("#shipping-calculator2 .loading").addClass("load");
    } else {
      $btn.removeClass("loading")
          .attr("value", "Calcular")
          .prop("disabled", false)
          .css("pointer-events", "");
      $("#shipping-calculator2 .loading").removeClass("load");
    }
  }

  function resetView() {
    // limpa resultados anteriores SEM depender do plugin
    $("#wrapper-response").empty().hide();
    $("#estimated-shipping em").empty();
    $("#shipping-calculator2").removeClass("shiping-loaded");
  }

  // (opcional) se você usar VMasker no CEP
  function inputHandler(masks, max, event) {
    var c = event.target;
    var v = c.value.replace(/\D/g, "");
    var m = c.value.length > max ? 1 : 0;
    VMasker(c).unMask();
    VMasker(c).maskPattern(masks[m]);
    c.value = VMasker.toPattern(v, masks[m]);
  }

  function carregaFrete(cep) {
    if ($("#address_zip").val().length != 9) {
      alert("Digite um cep válido");
      setBusy(false);
      return;
    }

    $.getJSON("//viacep.com.br/ws/" + cep + "/json/?callback=?", function (dados) {
      if (!("erro" in dados)) {
        if (!$("#shipping-calculator2.shiping-loaded")[0]) {
          $("#shipping-calculator2").addClass("shiping-loaded");
        }

        const uf = (dados.uf || "").toUpperCase();
        const map = {
          AC:"Acre", AL:"Alagoas", AM:"Amazonas", AP:"Amapá", BA:"Bahia", CE:"Ceará",
          DF:"Distrito Federal", ES:"Espírito Santo", GO:"Goiás", MA:"Maranhão",
          MG:"Minas Gerais", MS:"Mato Grosso do Sul", MT:"Mato Grosso", PA:"Pará",
          PB:"Paraíba", PE:"Pernambuco", PI:"Piauí", PR:"Paraná", RJ:"Rio de Janeiro",
          RN:"Rio Grande do Norte", RO:"Rondônia", RR:"Roraima", RS:"Rio Grande do Sul",
          SC:"Santa Catarina", SE:"Sergipe", SP:"São Paulo", TO:"Tocantíns"
        };
        const state = map[uf];
        if (state) {
          $('[name="address[province]"] option[value="' + state + '"]').prop("selected", true);
        }

        // Dispara o cálculo do plugin
        $(".get-rates").trigger("click");
      } else {
        alert("CEP não encontrado");
      }
    })
    .fail(function () {
      alert("Consulta de CEP indisponível no momento");
    })
    .always(function () {
      setBusy(false); // libera o botão ao final do fluxo
    });
  }

  // Enter no CEP: só aceita se não estiver busy
  $(document)
    .off("keypress.shippingCalc", "#address_zip")
    .on("keypress.shippingCalc", "#address_zip", function (event) {
      if (event.keyCode == 13) {
        event.preventDefault();
        if (!window.__freteBusy) $(".get-rates-custom").trigger("click");
      }
    });

  // Clique no botão customizado: debounce + lock + reset
  const handleCalcClick = debounceLeading(function () {
    if (window.__freteBusy) return; // já em cálculo

    resetView();   // limpa resultados pré-existentes
    setBusy(true); // trava o botão/estado

    const variantid = $("#variantid");
    const cep = $("#address_zip").val();

    const startCalc = () => carregaFrete(cep);

    if (variantid[0]) {
      const variantvalue = variantid.val();

      $.getJSON("/cart.js", function (cart) {
        const cartItens = cart.item_count || 0;

        if (cartItens === 0) {
          // adiciona item "fantasma", calcula e remove após 10s
          Shopify.addItem(variantvalue, 1, function () {
            startCalc();

            if (removeTimerId) clearTimeout(removeTimerId);
            removeTimerId = setTimeout(function () {
              Shopify.removeItem(variantvalue);
              removeTimerId = null;
            }, 10000);
          });
        } else {
          startCalc();
        }
      });
    } else {
      startCalc();
    }
  }, 600); // janela de 600ms: só o primeiro clique passa

  $(document)
    .off("click.shippingCalc", ".get-rates-custom")
    .on("click.shippingCalc", ".get-rates-custom", function (e) {
      // corta clique frenético
      if (window.__freteBusy) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      handleCalcClick();
    });
});
